export default __webpack_public_path__ + "static/media/room_bg.8668a442.jpg";